// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.recall[data-v-3fc413d9] {

    position: relative;

    padding-top: 5rem;

    padding-bottom: 5rem;

    padding-left: 1.5rem;

    padding-right: 1.5rem
}
@media (min-width: 996px) {
.recall[data-v-3fc413d9] {

        padding-top: 10rem;

        padding-bottom: 10rem
}
}
.recall__container[data-v-3fc413d9] {

    position: relative;

    display: flex;

    overflow: hidden;

    border-radius: 12px;

    --tw-bg-opacity: 1;

    background-color: rgb(234 178 38 / var(--tw-bg-opacity));

    padding-top: 4rem;

    padding-bottom: 4rem;

    width: 100%;

    padding-right: 1rem;

    padding-left: 1rem;

    margin: auto
}
@media (min-width: 640px) {
.recall__container[data-v-3fc413d9] {

        padding-right: 1.5rem;

        padding-left: 1.5rem;

        width: calc((100vw - 1.5rem) / 8 * 6 + 1.5rem)
}
}
@media (min-width: 996px) {
.recall__container[data-v-3fc413d9] {

        width: 100%
}
}
@media (min-width: 1320px) {
.recall__container[data-v-3fc413d9] {

        max-width: 1320px;

        width: calc((1320px - 1.5rem) / 12 * 8 + 1.5rem)
}
}
@media (min-width: 1536px) {
.recall__container[data-v-3fc413d9] {

        width: 100%
}
}
@media (min-width: 640px) {
.recall__container[data-v-3fc413d9] {

        padding-top: 7.5rem;

        padding-bottom: 5rem
}
}
@media (min-width: 996px) {
.recall__container[data-v-3fc413d9] {

        overflow: visible;

        padding-left: 7.5rem;

        padding-right: 7.5rem;

        padding-top: 4rem;

        padding-bottom: 5rem
}
}
@media (min-width: 1320px) {
.recall__container[data-v-3fc413d9] {

        padding-left: 5rem;

        padding-right: 5rem
}
}
@media (min-width: 1536px) {
.recall__container[data-v-3fc413d9] {

        padding-left: 12.5rem;

        padding-right: 12.5rem
}
}
.recall__moles[data-v-3fc413d9] {

    position: absolute;

    left: -12.5rem;

    bottom: -2rem;

    z-index: 0
}
@media (min-width: 996px) {
.recall__moles[data-v-3fc413d9] {

        display: none
}
}
.recall__wrapper[data-v-3fc413d9] {

    z-index: 0;

    padding-left: 1.5rem;

    padding-right: 1.5rem
}
@media (min-width: 996px) {
.recall__wrapper[data-v-3fc413d9] {

        padding-left: 0;

        padding-right: 0;

        width: calc((100vw - 1.5rem) / 8 * 3 - 1.5rem)
}
}
@media (min-width: 1320px) {
.recall__wrapper[data-v-3fc413d9] {

        width: calc((1320px - 1.5rem) / 12 * 3 - 1.5rem)
}
}
.recall__title[data-v-3fc413d9] {

    margin-bottom: 4rem;

    text-align: center;

    --tw-text-opacity: 1;

    color: rgb(17 24 39 / var(--tw-text-opacity));

    font-family: Mont;

    line-height: 1.35;

    font-size: 2rem;

    font-weight: 700
}
@media (min-width: 640px) {
.recall__title[data-v-3fc413d9] {

        margin-bottom: 1.5rem
}
}
@media (min-width: 996px) {
.recall__title[data-v-3fc413d9] {

        margin-bottom: 2.5rem;

        text-align: left
}
}
.recall__content[data-v-3fc413d9] {

    margin: auto;

    display: flex;

    max-width: 460px;

    flex-direction: column;

    align-items: center;

    gap: 1.5rem;

    text-align: center
}
@media (min-width: 996px) {
.recall__content[data-v-3fc413d9] {

        gap: 1rem
}
}
.recall__content > *[data-v-3fc413d9] {

    width: 100%
}
.recall__img[data-v-3fc413d9] {

    position: absolute;

    bottom: 0;

    display: none;

    width: 15.5rem
}
@media (min-width: 996px) {
.recall__img[data-v-3fc413d9] {

        right: 7.5rem;

        display: block
}
}
@media (min-width: 1320px) {
.recall__img[data-v-3fc413d9] {

        right: 5rem;

        width: 16.875rem
}
}
@media (min-width: 1536px) {
.recall__img[data-v-3fc413d9] {

        right: 12.5rem
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/ctas/Recall.vue"],"names":[],"mappings":";AAqCA;;IAAA,kBAAA;;IAAA,iBAAA;;IAAA,oBAAA;;IAAA,oBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,kBAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,kBAAA;;IAAA,aAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA,kBAAA;;IAAA,wDAAA;;IAAA,iBAAA;;IAAA,oBAAA;;IAAA,WAAA;;IAAA,mBAAA;;IAAA,kBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,qBAAA;;QAAA,oBAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,iBAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,mBAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,iBAAA;;QAAA,oBAAA;;QAAA,qBAAA;;QAAA,iBAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,kBAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,qBAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,cAAA;;IAAA,aAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,UAAA;;IAAA,oBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,eAAA;;QAAA,gBAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,mBAAA;;IAAA,kBAAA;;IAAA,oBAAA;;IAAA,6CAAA;;IAAA,iBAAA;;IAAA,iBAAA;;IAAA,eAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,qBAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,YAAA;;IAAA,aAAA;;IAAA,gBAAA;;IAAA,sBAAA;;IAAA,mBAAA;;IAAA,WAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA;AAAA;AAKA;;IAAA,kBAAA;;IAAA,SAAA;;IAAA,aAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,aAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,WAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA","sourcesContent":["<template>\n  <div class=\"recall\">\n    <div class=\"recall__container\">\n      <Moles class=\"recall__moles\" :count=\"1\" background=\"transparent\" align=\"right\" :scale=\"2.25\" reversed />\n      <div class=\"recall__wrapper\">\n        <h2 class=\"recall__title\">{{ title }}</h2>\n        <div class=\"recall__content\">\n          <slot />\n        </div>\n      </div>\n      <div class=\"recall__img\"><img :src=\"`/img/web/${image}.webp`\" alt=\"Imagen mujer\" /></div>\n    </div>\n  </div>\n</template>\n\n<script>\nimport Moles from '@/lego/components/layout/Moles.vue';\n\nexport default {\n  components: {\n    Moles,\n  },\n  props: {\n    title: {\n      type: String,\n      default: null,\n    },\n    image: {\n      type: String,\n      default: null,\n    },\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n.recall {\n  @apply relative py-xxl px-xxs lg:py-huge;\n\n  &__container {\n    @apply container relative flex overflow-hidden rounded-md container-thin bg-brand-primary-medium lg:overflow-visible py-xl sm:pt-xxxl sm:pb-xxl lg:pt-xl lg:pb-xxl lg:px-xxxl xl:px-xxl 2xl:px-giant;\n  }\n\n  &__moles {\n    @apply absolute z-0 lg:hidden -left-giant -bottom-xs;\n  }\n\n  &__wrapper {\n    @apply z-0 px-xxs lg:px-0 lg:col-3-8 xl:col-3-12;\n  }\n\n  &__title {\n    @apply text-center text-neutral-ultradark style-title-sm-bold mb-xl sm:mb-xxs lg:mb-sm lg:text-left;\n  }\n\n  &__content {\n    @apply flex flex-col gap-xxs lg:gap-xxxs items-center m-auto text-center max-w-content;\n\n    > * {\n      @apply w-full;\n    }\n  }\n\n  &__img {\n    @apply absolute bottom-0 hidden lg:block lg:right-xxxl xl:right-xxl 2xl:right-giant w-[15.5rem] xl:w-[16.875rem];\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
